import { get, post } from '@core/api/client';
import { endpoints } from '@core/api/endpoints';

export type BugReportStatus =
  | 'filed'
  | 'failed'
  | 'pending_review'
  | 'rejected';

export interface BugReport {
  id: string;
  tenantId: string;
  agentId: string;
  sessionId: string;
  summary: string;
  description: string;
  severity: string;
  stepsToReproduce: string;
  expectedBehavior: string;
  actualBehavior: string;
  environment: string | null;
  reporterEmail: string;
  reporterName: string | null;
  jiraIssueKey: string | null;
  jiraIssueUrl: string | null;
  fields: Record<string, string>;
  channel: 'web' | 'voice' | 'phone' | 'web_voice';
  status: BugReportStatus;
  errorCode: string | null;
  errorMessage: string | null;
  reviewedBy: string | null;
  reviewedAt: string | null;
  reviewNote: string | null;
  createdAt: string;
}

export interface ListBugReportsQuery {
  agentId?: string;
  status?: BugReportStatus;
}

export const bugReportService = {
  list(params?: ListBugReportsQuery): Promise<BugReport[]> {
    return get<BugReport[]>(endpoints.bugReports.list, { params });
  },

  getById(id: string): Promise<BugReport> {
    return get<BugReport>(endpoints.bugReports.getById(id));
  },

  /** Moderation: push a pending_review ticket to Jira. */
  approve(id: string): Promise<BugReport> {
    return post<BugReport>(endpoints.bugReports.approve(id));
  },

  /** Moderation: decline a pending_review ticket (never reaches Jira). */
  reject(id: string, note?: string): Promise<BugReport> {
    return post<BugReport>(endpoints.bugReports.reject(id), { note });
  },
};
